import { useCallback } from 'react';
import { usePanel } from './usePanel';
export function useFrameSelect(part) {
  var panel = usePanel(part);
  var frameSelectDate = useCallback(function (date, type) {
    panel.frameSelectDate(date, type);
  }, []);
  var frameSelectDateVirtual = useCallback(function (date, type) {
    panel.frameSelectDate(date, type, true);
  }, []);
  return {
    frameSelectDate: frameSelectDate,
    frameSelectDateVirtual: frameSelectDateVirtual
  };
}